import React, { useState, useRef, useEffect, useCallback } from "react";
import { Button, Modal } from "antd";
import iconFilter from "../assets/icon/icon_filter.png";
import "./modal.less";
const App = ({
	filterValues,
	content,
	btnCustom = null,
	modalCustom = null,
	isModalOpen,
	showModal,
	closeModal,
	isBack,
}) => {
	const [isMobile, setIsMobile] = useState(false);
	const [isMacAir, setIsMacAir] = useState(false);
	const buttonRef = useRef(null);

	const handleOk = () => {
		closeModal();
	};

	const handleCancel = () => {
		closeModal();
	};

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768);
		};

		handleResize();
		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	// Detect MacBook Air screens (13.3" and 15")
	useEffect(() => {
		const checkMacAir = () => {
			const width = window.innerWidth;
			const height = window.innerHeight;
			const screenWidth = window.screen?.width || width;
			const screenHeight = window.screen?.height || height;
			const devicePixelRatio = window.devicePixelRatio || 1;
			const logicalScreenWidth = screenWidth / devicePixelRatio;
			const logicalScreenHeight = screenHeight / devicePixelRatio;

			// MacBook Air 13.3": ~1440 x 900 logical
			// MacBook Air 15": ~1400 x 900 logical
			const matchesViewport =
				width >= 1300 && width <= 1500 && height >= 800 && height <= 1000;
			const matchesLogicalScreen =
				logicalScreenWidth >= 1300 &&
				logicalScreenWidth <= 1500 &&
				logicalScreenHeight >= 800 &&
				logicalScreenHeight <= 1000;
			const matchesPhysicalScreen =
				screenWidth >= 2800 &&
				screenWidth <= 2900 &&
				screenHeight >= 1800 &&
				screenHeight <= 1900;

			const isMacAirSize =
				matchesViewport || matchesLogicalScreen || matchesPhysicalScreen;
			setIsMacAir(isMacAirSize);
		};

		checkMacAir();
		window.addEventListener("resize", checkMacAir);
		return () => window.removeEventListener("resize", checkMacAir);
	}, []);
	useEffect(() => {
		// Calculate scrollbar width
		const scrollbarWidth =
			(window.innerWidth - document.documentElement.clientWidth) / 0.75; // Adjust for zoom level
		document.documentElement.style.setProperty(
			"--scrollbar-width",
			`${scrollbarWidth}px`
		);

		if (isModalOpen) {
			document.body.classList.add("no-scroll");
		} else {
			document.body.classList.remove("no-scroll");
		}

		// Cleanup function to remove the class on unmount
		return () => {
			document.body.classList.remove("no-scroll");
			document.documentElement.style.removeProperty("--scrollbar-width"); // Clean up
		};
	}, [isModalOpen, isMobile]);

	const modalWidth = 280;

	// Calculate modal position based on device type
	const getModalPosition = useCallback(() => {
		if (!buttonRef.current) return { top: 0, left: 0 };

		const rect = buttonRef.current.getBoundingClientRect();

		// Mac-specific positioning to fix the issue on MacBook Air screens
		if (isMacAir) {
			// Use different calculation for Mac to account for the zoom/safari rendering issue
			return {
				top: rect.bottom / 0.75 + 15,
				left: (rect.right - modalWidth - 80) / 0.75, // Align right edge with button's right edge, shift left by 80px to avoid cutoff
			};
		}

		// General design for other devices (Windows, etc.)
		return {
			top: rect.bottom / 0.75 + 15,
			left: (rect.left - modalWidth) / 0.75, // Center modal under button
		};
	}, [isMacAir, modalWidth]);

	const modalPosition = getModalPosition();

	return (
		<>
			<Button
				type="primary"
				onClick={showModal}
				ref={buttonRef}
				className={
					btnCustom
						? btnCustom
						: isModalOpen || filterValues?.length > 0 || isBack
						? "filterBtnSelected"
						: "filterresetBtn"
				}
			>
				<img
					style={{ marginRight: "5px" }}
					src={iconFilter}
					alt="Filter Icon"
				/>
				Filter
			</Button>
			{isModalOpen && (
				<Modal
					open={true}
					onOk={handleOk}
					onCancel={handleCancel}
					getContainer={false}
					footer={null}
					header={null}
					className={modalCustom ? modalCustom : "filter-modal"}
					style={{
						position: "absolute",
						top: modalPosition.top,
						left: modalPosition.left,
						width: "fit-content",
						maxWidth: "480px",
					}}
					mask={isMobile}
					maskClosable={true}
				>
					{content}
				</Modal>
			)}
		</>
	);
};

export default App;
